import React from "react";
import StatusPill from "ui-components/status-pill/statusPill";
import { ScanResultStatus } from "app/data/dock-scan/models";

const CheckIcon: React.FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const CrossIcon: React.FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

interface ScanResultTagProps {
  status: ScanResultStatus;
}

/** Result tag with SVG tick/cross inside the StatusPill. */
const ScanResultTag: React.FC<ScanResultTagProps> = ({ status }) => {
  const ok = status === "SUCCESS";
  return (
    <StatusPill
      label={ok ? "Success" : "Failed"}
      variant={ok ? "success" : "failure"}
      icon={ok ? <CheckIcon /> : <CrossIcon />}
    />
  );
};

export default ScanResultTag;
